import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الماء - اعرف كم يحتاج جسمك من الماء";
const DESCRIPTION =
  "كم يحتاج الجسم من الماء؟ احسب كمية المياه المناسبة التي يحتاجها جسمك حسب وزنك لتجنب الجفاف والأمراض بخطوات سهلة على الطبي.";
const KEYWORDS =
  "حاسبة كمية المياه, شرب الماء, صحة الجسم, احتياجات الماء اليومية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/daily-water-intake-calculator/";
function WaterIntakeCalculator() {
  const [weight, setWeight] = useState("");
  const [activityLevel, setActivityLevel] = useState("low");
  const [climate, setClimate] = useState("moderate");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleActivityLevelChange = (event) => {
    setActivityLevel(event.target.value);
  };
  const handleClimateChange = (event) => {
    setClimate(event.target.value);
  };
  const calculateWaterIntake = () => {
    const weightNum = parseFloat(weight);
    if (isNaN(weightNum) || weightNum <= 0) {
      setError("أدخل وزناً صحيحاً");
      setResult(null);
      return;
    }
    let baseIntake = weightNum * 0.033;
    if (activityLevel === "moderate") {
      baseIntake *= 1.2;
    } else if (activityLevel === "high") {
      baseIntake *= 1.4;
    }
    if (climate === "hot") {
      baseIntake *= 1.3;
    } else if (climate === "cold") {
      baseIntake *= 0.9;
    }
    const waterInLiters = baseIntake.toFixed(2);
    const waterInGlasses = (waterInLiters / 0.25).toFixed(0);
    setResult({ liters: waterInLiters, glasses: waterInGlasses });
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تساعدك حاسبة كمية المياه اليومية على تحديد الكمية المناسبة من
                  المياه التي يجب أن تشربها يوميًا بناءً على وزنك، مستوى نشاطك،
                  والمناخ الذي تعيش فيه. يمكن أن تساعدك هذه الحاسبة في الحفاظ
                  على ترطيب جسمك وصحتك العامة. شرب كمية كافية من الماء يومياً
                  يعتبر أمرًا حيويًا للمساعدة في الحفاظ على وظائف الجسم
                  الطبيعية، بما في ذلك تنظيم درجة حرارة الجسم، نقل المواد
                  الغذائية، وترطيب البشرة. بالإضافة إلى ذلك، يمكن أن يساعد شرب
                  الكمية المناسبة من الماء في تحسين الهضم، تقليل الشعور
                  بالإرهاق، وزيادة مستوى الطاقة لديك.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-10 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة كمية المياه اليومية
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weight" className="form-label ms-2">
                      الوزن (كجم)
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weight"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="كجم"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="activityLevel" className="form-label ms-2">
                      مستوى النشاط
                    </label>
                  </b>
                  <select
                    id="activityLevel"
                    value={activityLevel}
                    onChange={handleActivityLevelChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="low">منخفض</option>
                    <option value="moderate">متوسط</option>
                    <option value="high">مرتفع</option>
                  </select>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="climate" className="form-label ms-2">
                      المناخ
                    </label>
                  </b>
                  <select
                    id="climate"
                    value={climate}
                    onChange={handleClimateChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="moderate">معتدل</option>
                    <option value="hot">حار</option>
                    <option value="cold">بارد</option>
                  </select>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateWaterIntake}
                  >
                    احسب                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-7">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>حدث خطأ:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <h4>النتيجة:</h4>
                      <hr />
                      <p>كمية الماء اليومية الموصى بها هي:</p>
                      <p style={{ fontWeight: "bold" }}>
                        يجب أن تشرب {result.glasses} أكواب من الماء، أي ما يعادل{" "}
                        {result.liters} لتر.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h2 style={{ fontSize: "18px" }}>كيف احسب كمية الماء التي يحتاجها جسدي يوميا</h2>
            </div>
            <div className="info-section-body">
              <p>{DESCRIPTION}</p>
              <div>
                <h3 style={{ fontSize: '16px' }}>كم يحتاج الجسم من الماء؟</h3>
                <p>احسب كمية المياه المناسبة التي يحتاجها جسمك حسب وزنك لتجنب الجفاف والأمراض بخطوات سهلة باستخدام حاسبة الماء على الطبي. حاسبة كمية الماء التي يحتاجها الجسم يومياً.</p>
                <p>هل تشرب الماء عند الشعور بالعطش فقط؟ هذه عادة خاطئة حتماً؛ لأن الشعور بالعطش هو تحذير بأن جسمك يعاني من الجفاف وأنك يجب شرب الماء بسرعة. تساعدك هذه الحاسبة على حساب كمية الماء التي يجب عليك شربها يومياً (حسب وزنك وعمرك) لتجنب الإصابة بالجفاف.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>كم لتر ماء يحتاج الجسم في اليوم؟</h3>
                <p>أدخل عمرك ووزنك في حاسبة الماء لتعرف كمية الماء التي يجب عليك شربها يومياً لتحافظ على صحتك وتتجنب الإصابة بالجفاف.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>كمية الماء الموصى بها يومياً</h3>
                <p>تختلف كمية الماء الموصى بها يومياً بشكل كبير بناءً على عوامل مثل العمر والجنس وحجم الجسم ومستوى النشاط اليومي والبيئة الفيزيائية. حاسبة الماء تأخذ كل هذه العوامل في الاعتبار لتوفير حساب دقيق.</p>
                <p>على سبيل المثال، يحتاج الرياضيون عادة إلى سوائل إضافية بسبب فقدان الماء من الجهد البدني المكثف. بالمثل، قد يحتاج الأشخاص الذين يعيشون في المناخات الاستوائية إلى مزيد من الماء لتعويض التعرق الزائد بسبب درجات الحرارة المرتفعة.</p>
                <p>تحتاج النساء الحوامل والمرضعات أيضاً إلى زيادة استهلاك السوائل لدعم احتياجات أجسامهن وصحة أطفالهن. قد يتراوح هذا من 500 مل إلى 2 لتر يومياً.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>لماذا يعتبر شرب الماء مهمًا؟</h3>
                <p>الماء ضروري للحياة ويعتبر أكثر العناصر الغذائية حيوية. غيابه يمكن أن يكون قاتلاً في غضون أيام قليلة. الماء مهم لوظائفنا الجسدية والعقلية، وهو ضروري لجميع وظائف الأيض لدينا بما في ذلك تنظيم درجة الحرارة، توصيل الأعصاب، والعديد من التفاعلات الكيميائية. نحافظ على حالتنا الطبيعية من الترطيب أو التوازن المائي من خلال التحكم في تناول الماء وفقدانه.</p>
                <p>من الغريب أن مسألة الكمية المثلى من الماء لا تزال غير واضحة وغير محددة بدقة، ولكن النطاق التقريبي وتجنب العطش يعتبران مؤشرات جيدة لتجنب الجفاف.</p>
                <p>اتبع 3 خطوات بسيطة باستخدام حاسبة الماء لمعرفة ما إذا كنت تشرب كمية كافية من الماء. ستقوم الحاسبة بحساب مستوى الترطيب الخاص بك بناءً على المعلومات التي تقدمها عن نفسك وعاداتك اليومية في شرب الماء.</p>
              </div>
              <hr />
              <div>
                <p>بعض من هذه التوصيات مستمدة من <a href="https://www.medindia.net" rel="nofollow noreferrer">medindia.net</a> و <a href="https://www.hydrationforhealth.com/en/hydration-tools/hydration-calculator/" rel="nofollow noreferrer">Hydration for Health</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WaterIntakeCalculator;
